import { Table, type TableProps } from 'antd'
import type { Source, SourceStage } from '~app/graph/generated/graphql'
import useSourcesColumnConfig from './useSourcesColumnConfig'
import { UpdatingContext, useUpdatingContexState } from './useUpdatingContext'

interface Props extends TableProps<Source> {
  sources: Source[]
  stages?: SourceStage[]
  refetchData: VoidFunction
}

const SourcesTable = ({
  loading,
  sources,
  onChange,
  stages,
  refetchData,
}: Props) => {
  // This is used to track which items are being updated (mutaions in progress)
  const { updating, setUpdating } = useUpdatingContexState()

  // Column definitions
  const columns = useSourcesColumnConfig({
    stages,
    onActionDone: refetchData,
  })
  return (
    <UpdatingContext.Provider
      value={{
        updating,
        setUpdating,
      }}
    >
      <Table
        loading={loading}
        locale={{ emptyText: 'No sources' }}
        dataSource={sources}
        pagination={false}
        columns={columns}
        rowClassName={() => 'editable-row'}
        rowKey={'id'}
        onChange={onChange}
        size={'middle'}
        className="sourcesTable"
      />
    </UpdatingContext.Provider>
  )
}

export default SourcesTable
